import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Banner.css"; // 🔹 NEW

const Banner = ({ image, heading }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const containerStyle = {
    backgroundImage: `url(${image})`,
    backgroundSize: "cover", // Ensures the image covers the entire container
    backgroundPosition: "center center", // Centers the image vertically and horizontally
    backgroundRepeat: "no-repeat", // Prevents the image from repeating
    backgroundAttachment: "fixed", // Parallax-style effect (as you had)
    height: "90vh", // Sets the height to 90% of the viewport height
    width: "100%", // Ensures full width
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    textAlign: "left",
    flexDirection: "column",
    paddingLeft: windowWidth > 768 ? "100px" : "10%",
    paddingTop: "5%",
    overflow: "hidden", // Prevents content overflow on smaller screens
  };

  const textContainerStyle = {
    maxWidth: windowWidth > 1200 ? "50%" : "80%", // Heading and button end halfway across on large screens
  };

  const headingStyle = {
    fontFamily: "Poppins, system-ui",
    fontSize:
      windowWidth > 1200
        ? "3.5rem"
        : windowWidth > 768
        ? "3rem"
        : windowWidth > 480
        ? "2rem"
        : "1.5rem",
    fontWeight: "700",
    color: "#ffffff",
    margin: "0 0 20px 0", // Space between heading and button
  };

  const buttonStyle = {
    backgroundColor: "#7ed3f7",
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    fontSize: "1rem",
    fontFamily: "Poppins, system-ui",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    marginTop: "20px",
  };

  const buttonHoverStyle = {
    backgroundColor: "#6ac2e4",
  };

  return (
    <div style={containerStyle}>
      <div style={textContainerStyle}>
        <h4 style={headingStyle}>{heading}</h4>
        <button
          style={buttonStyle}
          className="banner-cta-electric" // 🔹 NEW
          onMouseEnter={(e) =>
            (e.target.style.backgroundColor = buttonHoverStyle.backgroundColor)
          }
          onMouseLeave={(e) =>
            (e.target.style.backgroundColor = buttonStyle.backgroundColor)
          }
          onClick={() => navigate("/contact#contactusform")}
        >
          Contact Us
        </button>
      </div>
    </div>
  );
};

export default Banner;
